
//import liraries
import React, { useEffect, useState } from "react";
import {View, Text, TouchableOpacity,} from "react-native";
import QuickLinks from "../../SubComponents/Profile/QuickLinks";
import CustomButton from "../../common/CustomButton";
import ModalAlert from "../../common/ModalAlert";
import * as RootNavigation from "../../utilities/RootNavigation";
import { getPoolAccountdetail } from "../../api/apiManager";
import useStyles from "./Transfer_PoolToTag_Styles";

const Transfer_PoolToTag = (props) => {
  const [value, setValue] = useState("Pool To Tag");
  const styles = useStyles();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
    RootNavigation.navigate("Home", {
      screen: "Profile",
      params: {
        screen: "Pool Account Details",
        selectedLayout: "Change Manual",
      },
    });
  };

  const renderPoolToTag = () => {
    RootNavigation.navigate("Transfer/PoolToTag", { value: value });
  };
  const renderTagToTag = () => {
    RootNavigation.navigate("Transfer/PoolSelection", { value: value });
  };
  const renderTagToPool = () => {
    RootNavigation.navigate("Transfer/PoolSelection", { value: value });
  };

  useEffect(() => {
    getPoolAccountDtls();
    if (data?.autopayEnabledFlag == "Y") {
      setAlertModalVisible(true);
      setAlertModal({
        title: "Alert",
        status: "error",
        message: "For fund transfer first kindly disable the Auto pay",
        navigateScreen: "",
        actionButton: "Change",
      });
    }
  }, []);

  const getPoolAccountDtls = () => {
    setLoading(true);
    getPoolAccountdetail()
      .then((res) => {
        setLoading(false);
        setData(res || {});
        if (res?.autopayEnabledFlag == "Y") {
          setAlertModalVisible(true);
          setAlertModal({
            title: "Alert",
            status: "error",
            message: "For fund transfer first kindly disable the Auto pay",
            navigateScreen: "",
            actionButton: "Change",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  return (
    <View style={styles.mainContainer}>
      <View style={styles.container}>
        <Text style={styles.textStyle}>{"Transfer Options"}</Text>
      </View>

      <View style={styles.subContainer}>
        <View style={{ paddingTop: 20 }}>
          <View>
            <Text style={styles.textOptions}>{"3 Versatile Options"}</Text>
            <Text style={styles.subText}>
              {"Transfers can be made in three different cases listed below"}
            </Text>
          </View>

          <View style={styles.boxContainer}>
            <View
              style={[
                styles.box,
                {
                  backgroundImage:
                    value == "Pool To Tag"
                      ? "linear-gradient( #bd2d37 -80%, #ffffff 50%)"
                      : null,
                },
              ]}
            >
              <View style={styles.boxHeading}>
                <Text style={styles.boxHeadingText}>Pool To Tag Transfer</Text>
              </View>

              <View style={styles.boxText}>
                <Text style={styles.boxText}>
                  Pool to Tag transfer lets you transfer amount from your Pool
                  account to a particular Tag
                </Text>
              </View>
            </View>
            <View
              style={[
                styles.box,
                {
                  backgroundImage:
                    value == "Tag To Pool"
                      ? "linear-gradient( #bd2d37 -80%, #ffffff 50%)"
                      : null,
                },
              ]}
            >
              <View style={styles.boxHeading}>
                <Text style={styles.boxHeadingText}>
                  {"Tag to Pool Transfer"}
                </Text>
              </View>

              <View style={styles.boxText}>
                <Text style={styles.boxText}>
                  {
                    "Tag to pool transfer lets you transfer amount from a particular Tag to your pool account"
                  }
                </Text>
              </View>
            </View>

            <View
              style={[
                styles.box,
                {
                  backgroundImage:
                    value == "Tag To Tag"
                      ? "linear-gradient( #bd2d37 -80%, #ffffff 50%)"
                      : null,
                },
              ]}
            >
              <View style={styles.boxHeading}>
                <Text style={styles.boxHeadingText}>
                  {"Tag to Tag Transfer"}
                </Text>
              </View>

              <View style={styles.boxText}>
                <Text style={styles.boxText}>
                  {
                    "Tag to Tag transfer lets you transfer amount from one Tag to another Tag linked to your account"
                  }
                </Text>
              </View>
            </View>
          </View>
        </View>

        <View>
          <View style={styles.chooseTransferView}>
            <Text style={styles.chooseTransferType}>
              {"Choose Transfer Type"}
            </Text>
            <Text style={styles.subText}>
              {"Based on the description choose the transfer type"}
            </Text>
          </View>

          <View style={styles.selectionContainerStyle}>
            <TouchableOpacity
              onPress={() => setValue("Pool To Tag")}
              style={styles.radiobuttonOutSideStyle}
            >
              {value == "Pool To Tag" ? (
                <View style={styles.radioButtonInsideStyle} />
              ) : null}
            </TouchableOpacity>
            <Text style={styles.radioText}>{"Pool To Tag"}</Text>
          </View>

          <View style={styles.selectionContainerStyle}>
            <TouchableOpacity
              onPress={() => setValue("Tag To Pool")}
              style={styles.radiobuttonOutSideStyle}
            >
              {value == "Tag To Pool" ? (
                <View style={styles.radioButtonInsideStyle} />
              ) : null}
            </TouchableOpacity>
            <Text style={styles.radioText}>{"Tag To Pool"}</Text>
          </View>

          <View style={styles.selectionContainerStyle}>
            <TouchableOpacity
              onPress={() => setValue("Tag To Tag")}
              style={styles.radiobuttonOutSideStyle}
            >
              {value == "Tag To Tag" ? (
                <View style={styles.radioButtonInsideStyle} />
              ) : null}
            </TouchableOpacity>
            <Text style={styles.radioText}>{"Tag To Tag"}</Text>
          </View>

          <View style={styles.customButton}>
            <CustomButton
              text="Proceed to Transfer"
              onPress={() => {
                value == "Pool To Tag"
                  ? renderPoolToTag()
                  : value == "Tag To Pool"
                  ? renderTagToPool()
                  : value == "Tag To Tag"
                  ? renderTagToTag()
                  : null;
              }}
            />
          </View>
        </View>
      </View>

      <View style={styles.quickLinksView}>
        <QuickLinks navigation={props.navigation} />
      </View>
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"Change"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
    </View>
  );
};


//make this component available to the app
export default Transfer_PoolToTag;

